<template>
  <div class="loginIndex">
    <div class="head_box">
      <div class="pictureDiv">
        <div>
          <img v-show="showImageIndex==0" src="@/assets/png/indexBackGroupImage1.png"/>
          <img v-show="showImageIndex==1" src="@/assets/png/indexBackGroupImage2.png"/>
        </div>
      </div>
      <div class="totalNumber">
        <div>
          <div>
            <p>120000<span>￥</span></p>
            <p>账户余额</p>
          </div>
          <div>
            <p>120000<span>分</span></p>
            <p>积分</p>
          </div>
          <div>
            <p>120000<span>￥</span></p>
            <p>奖励金</p>
          </div>
          <div>
            <p>15<span>张</span></p>
            <p>优惠券</p>
          </div>
        </div>
        <div>
          <div>
            <p>1000<span>个</span></p>
            <p>客户的询单</p>
          </div>
          <div>
            <p>120000<span>个</span></p>
            <p>客户的订单</p>
          </div>
          <div>
            <p>120000<span>个</span></p>
            <p>客户的提问</p>
          </div>
          <div>
            <p>16666<span>个</span></p>
            <p>客户的评价</p>
          </div>
        </div>
        <div>
          <div>
            <p>1000<span>个</span></p>
            <p>客户的发票</p>
          </div>
          <div>
            <p>120000<span>个</span></p>
            <p>我的采购</p>
          </div>
          <div>
            <p>120000<span>个</span></p>
            <p>待确认的采购</p>
          </div>
          <div>
            <p>16666<span>个</span></p>
            <p>我的方案</p>
          </div>
        </div>
        <div>
          <div>
            <p>1000<span>个</span></p>
            <p>我发出的询价</p>
          </div>
          <div>
            <p>120000<span>个</span></p>
            <p>我收到的回复</p>
          </div>
          <div>
            <p>120000<span>个</span></p>
            <p>营销活动</p>
          </div>
          <div>
            <p>16666<span>个</span></p>
            <p>我的收藏</p>
          </div>
        </div>
      </div>
      <div class="image">
        <img style="width:100%;height: 2.5rem;object-fit: cover" src="@/assets/png/dataManage.png"/>
      </div>
      <div class="tongjishuju">
        <div>
          <div>
            <div class="type">
              <div class="typeDiv no1">定制<br>线路</div>
              <div class="typeDiv no2">跟团</div>
              <div class="typeDiv no3">酒店</div>
              <div class="typeDiv no4">景点</div>
              <div class="typeDiv no5">用车</div>
            </div>
            <div>
              <p>我客户的交易偏好</p>
              <p>新增粉丝</p>
            </div>
          </div>
          <div>
            <div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <span>人</span>
            </div>
            <div>
              <p>我的累计实名用户</p>
              <p>2021.11.05 13:00:00</p>
              <p>昨日新增 287 环比增长20%</p>
            </div>
          </div>
          <div>
            <div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <span>人</span>
            </div>
            <div>
              <p>我的累计分销达人</p>
              <p>2021.11.05 13:00:00</p>
              <p>昨日新增 287 环比增长20%</p>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <span>人</span>
            </div>
            <div>
              <p>我的累计关注</p>
              <p>2021.11.05 13:00:00</p>
              <p>昨日新增 287 环比增长20%</p>
            </div>
          </div>
          <div>
            <div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <span>人</span>
            </div>
            <div>
              <p>我的累计粉丝</p>
              <p>2021.11.05 13:00:00</p>
              <p>昨日新增 287 环比增长20%</p>
            </div>
          </div>
          <div>
            <div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <div class="numberDiv">0</div>
              <span>人</span>
            </div>
            <div>
              <p>我的活跃客户数（最近7天）</p>
              <p>2021.11.05 13:00:00</p>
              <p>昨日新增 287 环比增长20%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      showImageIndex:0,
    }
  },
  mounted(){

  }
}
</script>

<style lang="scss" scoped>
.loginIndex{
  background-color: white;
  .head_box{
    //margin-top: 0.2rem;
    .pictureDiv{
      img{
        object-fit: cover;
        height: 6rem;
        width: 100%;
      }
    }
  }
  .tongjishuju{
    width: 12rem;
    margin: 0 auto;
    padding-top: 0.5rem;
    >div{
      display: flex;
      justify-content: space-between;
      >div{
        margin-bottom: 0.2rem;
        >div:first-child{
          height: 0.8rem;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 3.5rem;
        }
        .type{
          .typeDiv{
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .no1{
            width: 0.8rem;
            height: 0.8rem;
            background: #E5AA25;
            font-size: 0.18rem;
          }
          .no2{
            width: 0.7rem;
            height: 0.7rem;
            background: #4F95FF;
            font-size: 0.2rem;
          }
          .no3{
            width: 0.6rem;
            height: 0.6rem;
            background: #C42267;
            font-size: 0.18rem;
          }
          .no4{
            width: 0.5rem;
            height: 0.5rem;
            background: #35ADA7;
            font-size: 0.16rem;
          }
          .no5{
            width: 0.38rem;
            height: 0.38rem;
            background: #445097;
            font-size: 0.12rem;
          }
        }
        .numberDiv{
          width: 0.2rem;
          height: 0.5rem;
          text-align: center;
          line-height: 0.5rem;
          color: white;
          font-weight: bold;
          margin-right: 8px;
          background: #35ADA7;
          font-size: 0.18rem;
        }
        >div:last-child{
          text-align: center;
          margin-top: 0.2rem;
          >p:first-child{
            font-size: 0.25rem;
            color: black;
          }
          >p:nth-child(2){
            margin-top: 0.15rem;
          }
          >p:not(:first-child){
            font-size: 0.14rem;
            color: rgb(102, 102, 102);
          }
        }
      }

    }
  }
  .image{
    margin-top: 0.5rem;
  }
  .totalNumber{
    padding-top: 0.4rem;
    width: 12rem;
    margin: 0 auto;
    >div{
      display: flex;
      justify-content: space-between;
      align-items: center;
      >div:last-child{
        border-right:1px solid #EAEAEA;
      }
      >div:hover{
        box-shadow: 3px 3px 7px -1px rgba(0, 0, 0, 0.4);
      }
      >div{
        width: 3rem;
        text-align: center;
        border: 1px solid #EAEAEA;
        border-right: none;
        padding: 0.2rem;
        >p{
          color: black;
        }
        >p:first-child{
          font-size: 0.4rem;
          font-family: '仿宋';
          color: #606266;
          >span{
            font-size: 0.2rem;
          }
        }
        >p:last-child{
          font-size: 0.14rem;
          color: rgb(102, 102, 102);
          margin-top: 0.2rem;
        }
      }
      >p{
        width: 0.05rem;
        height: 0.6rem;
        border-right: 1px solid #EAEAEA;
      }
    }
  }
}
</style>
